import "core-js/modules/es.array.push.js";
import { mapActions } from "vuex";
import SelctUnit from "@/views/Login/SelctUnit";
import { unitsTree } from "@/service/user";
export default {
  name: "CommunicationUser",
  components: {
    SelctUnit
  },
  mounted() {
    this.getUnitTree();
  },
  methods: {
    ...mapActions(["handleLogOut"]),
    async onLogout() {
      const res = await this.handleLogOut();
      if (res && res.result === 0) {
        this.$router.push({
          name: "Login"
        });
      }
    },
    async getUnitTree() {
      let res = await unitsTree();
      if (res.data && res.data.result === 0) {
        let units = res.data.retVal;
        if (units.length > 0) {
          // 如果加入单位，重新登录
          this.onLogout();
        }
      }
    },
    join(type) {
      this.$refs["SelctUnit"].join(type);
    }
  }
};